import { createApp, h } from 'vue';
import { vuetify, translator } from '@complispace/cs-design-system';
import * as CSDesignSystem from '@complispace/cs-design-system';
import JsonEditorVue from 'json-editor-vue';
import App from './App';
import router from './router';
import store from './store';
import SlotIndicator from './components/SlotIndicator';
import '@complispace/cs-design-system/style.css';
import '@ideagen-hlx/helix-vue/dist/style.css';

const options = {
  store,
  router,
  auth0: {
    appHost: window.location.host,
    appUrl: window.location.origin,
    auth0Domain: import.meta.env.VITE_AUTH0_DOMAIN,
    auth0ClientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
    auth0Audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    appEnv: import.meta.env.VITE_APP_ENV || 'develop'
  },
  gainsight: {
    gainsightSiteInfoApiHost: import.meta.env.VITE_GAINSIGHT_SITE_INFO_API_HOST,
    gainsightProductTag: import.meta.env.VITE_GAINSIGHT_PRODUCT_TAG,
    gainsightAppName: import.meta.env.VUE_APP_GAINSIGHT_APP_NAME || 'cs-design-system-docs'
  },
  login: {
    resetBtnTimeout: parseInt(import.meta.env.VITE_LOGIN_RESET_TIMEOUT || 5, 10)
  }
};

const app = createApp({
  render: () => h(App)
});

app.component('SlotIndicator', SlotIndicator);

const modules = import.meta.glob('./resources/i18n/*', { eager: true });
translator.applyAppI18n(modules);

// Complispace design system
app.use(CSDesignSystem, options);
app.use(vuetify);
app.use(router);
app.use(store);

app.use(JsonEditorVue, {
  // global props & attrs (one-way data flow)
});
app.mount('#app');
